module.exports = __webpack_public_path__ + "source/img/thumb-down-fill.d59154a9.svg";